// JavaScript Document
//components/signs/Signs.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
	maxHeight:'calc(100vh - 84px)',
	//maxHeight: '100%'
  },
});


export default function TypesTable(props) {
	const classes = useStyles();
	const {items, showtype, onSelect} = props;
	const humanType = (type) => {
		if(type === 'sign_type'){
			return 'Sign';
		} else if(type === 'sign_class'){
			return 'Class';
		} else if(type === 'sign_category'){
			return 'Category';
		} else if(type === 'option'){
			return 'Option';
		}
		return 'Unknown';
	}
	
	const handleSelect = (row) => {
		if(onSelect){
			onSelect(row);
		}
	}
	

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="sign types list">
        <TableHead>
          <TableRow>
	  		{showtype? (<TableCell>Type</TableCell>): ''}
	  		<TableCell></TableCell>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
	  		<TableCell>Size</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow hover role="checkbox" key={row.id} onClick={(e) => {handleSelect(row)}}>
	  			{showtype ? (<TableCell>{humanType(row.type)}</TableCell>) : ''}
	  		  <TableCell style={{
	  				backgroundImage:'url("http://forteltraffic.com/'+row.pic_path+'")', 
	  				backgroundSize:'contain', 
	  				backgroundRepeat:'no-repeat', 
	  				backgroundPosition:'center'
	  			}}> </TableCell>
              <TableCell component="th" scope="row">
                {row.name}
              </TableCell>
	  			<TableCell>{row.description}</TableCell>
	  			<TableCell>{row.opt_width > 0 && row.opt_height > 0 ? row.opt_width+' x '+row.opt_height : ''}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
